import React from 'react';

const AuthLayout = (props: { children: React.ReactNode }) => {
  const { children } = props;

  return (
    <main className="flex min-h-screen flex-col bg-bleu-hellio-1 px-4 py-6 sm:px-6 sm:py-10">
      {children}
    </main>
  );
};

export default React.memo(AuthLayout);
